import React from 'react'

type ButtonProps = {
    href: string
    children: React.ReactNode
}

export const Button = ({ href, children }: ButtonProps) => {
    return (
        <a
            href={href}
            className="pointer-events-auto mt-0 mb-[60px] w-[300px] text-center leading-[36px] font-bold text-white"
            style={{
                backgroundColor: 'rgb(97, 87, 255)',
            }}
        >
            {children}
        </a>
    )
}
